import { render, staticRenderFns } from "./CoSignerInReview.vue?vue&type=template&id=1734a40d&"
import script from "./CoSignerInReview.vue?vue&type=script&lang=js&"
export * from "./CoSignerInReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports